/* eslint-disable react/prop-types */
import {
	Avatar,
	Box,
	Checkbox,
	Typography,
	Tooltip,
	Chip,
	useTheme,
} from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import { capitalize } from '../../hepler/functions';
import stylesLogo from './Account.styles';
import sizeFontCustom from '../Discovery/fontSize.styles';
import { useTranslation } from '../../hooks/useTranslation';
import { isAccountMandatory } from '../../utils/targetedAccounts.utils';

function AccountCheckBox(props) {
	// eslint-disable-next-line no-unused-vars
	const { t } = useTranslation();
	const theme = useTheme();
	const {
		acc,
		checkedItems,
		handleCheckboxChange,
		selectedAccounts,
		consent,
		superState,
		fip,
		accountRestrictions,
		...rest
	} = props;
	const isActiveFlag = rest?.selectedConsentsState?.includes(
		rest?.consentHandle
	)
		? true
		: false;

	const isMandatory = isAccountMandatory(acc);

	// Check if this account is restricted for the current consent
	const accountRestriction = accountRestrictions?.[acc?.accRefNumber];
	const isRestricted = accountRestriction?.isRestricted || false;
	const restrictionReason = accountRestriction?.reason || '';

	// Check for dark theme
	const isDark =
		rest.customDetails?.darkTheme === true || theme.palette.mode === 'dark';

	// Determine if checkbox should be checked and disabled
	// Use accRefNumber comparison instead of object reference
	const isChecked = consent
		? superState?.consentSelectedAccounts[consent.ConsentHandle]?.some(
				(selected) => selected.accRefNumber === acc.accRefNumber
		  )
		: selectedAccounts?.some(
				(selected) => selected.accRefNumber === acc.accRefNumber
		  ) || false;

	// Only disable if consent is not active OR account is restricted
	const isDisabled = !isActiveFlag || isRestricted || isMandatory;

	const handleClick = (e) => {
		// Only prevent click if account is restricted
		if (isRestricted) {
			e.preventDefault();
			e.stopPropagation();
			return;
		}

		// For non-restricted accounts, allow the click
		handleCheckboxChange(e, acc, isMandatory);
	};

	return (
		<Tooltip
			title={isRestricted ? restrictionReason : ''}
			arrow
			placement="top"
			disableHoverListener={!isRestricted}
		>
			<Box
				onClick={handleClick}
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					cursor: isRestricted ? 'not-allowed' : 'pointer',
					alignItems: 'flex-start',
					p: '1rem',
					opacity: isRestricted ? 0.6 : 1,
				}}
			>
				<Box sx={stylesLogo.container}>
					<Avatar
						alt={acc?.name}
						src={global.objectFormatFip[acc?.fipId]?.productIconUri}
						sx={stylesLogo.avatarStyle}
					/>
					<Box textAlign={'left'}>
						<Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
							<Typography sx={sizeFontCustom.subHeading} noWrap={false}>
								{t(`fips.${global.objectFormatFip[acc?.fipId]?.fipId}`)}
							</Typography>
							{acc?.isLinked && global.isFlowChange === 'true' && (
								<Chip
									icon={
										<LinkIcon
											sx={{
												fontSize: '0.875rem !important',
												color: '#2e7d32 !important',
												transform: 'rotate(-45deg)',
											}}
										/>
									}
									label={t('paymentConsent.labels.linked')}
									size="small"
									sx={{
										height: '20px',
										fontSize: '0.65rem',
										fontWeight: 600,
										backgroundColor: 'transparent',
										color: '#2e7d32',
										border: 'none',
										'& .MuiChip-label': {
											padding: '0 0.375rem',
										},
										'& .MuiChip-icon': {
											marginLeft: '0.25rem',
											marginRight: '-0.125rem',
										},
									}}
								/>
							)}
						</Box>

						<Typography sx={stylesLogo.account}>
							{capitalize(acc?.accType) +
								' ' +
								acc?.maskedAccNumber?.replaceAll('X', '\u2022')}
						</Typography>
					</Box>
				</Box>
				<Box>
					<Checkbox
						name={acc?.accRefNumber}
						disabled={isDisabled}
						size="small"
						sx={{ height: '18px', width: '18px' }}
						checked={isChecked}
						onChange={(e) => {
							// Only handle change if not restricted
							if (!isRestricted) {
								handleCheckboxChange(e, acc);
							}
						}}
					/>
				</Box>
			</Box>
		</Tooltip>
	);
}

export default AccountCheckBox;
